<template>
  <v-card>
    <v-card-title>Historical Issues Params</v-card-title>

    <v-card-text>
        <v-form ref="historicalParams" v-model="historicalParamsFormValid" :lazy-validation="true">
            <v-row dense >

                <v-col cols="12" md="6">
                    <v-datetime-picker label="Start Date/Time" v-model="historicalParams.startDateTime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                </v-col>
                <v-col cols="12" md="6">
                    <v-datetime-picker label="End Date/Time" v-model="historicalParams.endDateTime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                </v-col>

                <v-col cols="12">
                <span>Enter the parameters on which you want to filter issues or leave a parameter blank to not filter on that parameter. An asterisk (*) can be used to match patterns</span>
                </v-col>

                <v-col cols="12" md="6">
                <v-text-field label="Issue Number" v-model="historicalParams.issueNumber" color="#c42111" :rules="[!historicalParams.issueNumber || $store.state.validationFuncs.positiveInteger(historicalParams.issueNumber, 'Issue Number')]"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field label="Office" v-model="historicalParams.office" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field label="Location" v-model="historicalParams.location" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field label="Keywords" v-model="historicalParams.keywords" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Category" multiple v-model="historicalParams.categories" :items="categoryList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Service" multiple v-model="historicalParams.services" :items="serviceList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Status" multiple v-model="historicalParams.statuses" :items="statusList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Priority" multiple v-model="historicalParams.priorities" :items="priorityList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Severity" multiple v-model="historicalParams.severities" :items="severityList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Owner" multiple v-model="historicalParams.owners" :items="ownerList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                <v-select label="Creator" multiple v-model="historicalParams.creators" :items="creatorList" color="#c42111"></v-select>
                </v-col>

                <v-col cols="12" md="6">
                    <v-select label="Tags" multiple v-model="historicalParams.tags" :items="issueTags" item-value="issue_tag_id" item-text="issue_tag_name" color="#c42111" />
                </v-col>

            </v-row>
        </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text @click="runClick">Run</v-btn>
        <v-btn text @click="$emit('cancel')">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: 'HistoricalParams',
    props: ['historicalIssuesParams'],
    components: {

    },
    data: () => ({
        historicalParamsFormValid: true,
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111'
        },
        dpProps: {
            color: '#c42111'
        },

        categoryList: [],
        serviceList: [],
        statusList: ['Open', 'In Progress', 'Monitoring', 'Delinquent', 'Completed', 'Closed', 'Duplicate'],
        priorityList: ['Highest', 'High', 'Normal', 'Low'],
        severityList: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        ownerList: [],
        creatorList: [],
        issueTags: [],

        historicalParams: {
            startDateTime: TELSA.moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
            endDateTime: TELSA.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            issueNumber: '',
            office: '',
            location: '',
            keywords: '',
            categories: [],
            services: [],
            statuses: [],
            priorities: [],
            severities: [],
            owners: [],
            creators: [],
            tags: []
        }
    }),

    computed: {
    },

    methods: {
        getResources: function() {
            let route = (TELSA.apiHost + "issues/resources");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.categoryList = result.categories;
                this.serviceList = result.services;

                let userUsernames = [];
                this.$store.state.batchConfig.users.forEach(user => {
                    userUsernames.push(user.user_username);
                });

                this.ownerList = userUsernames;
                this.creatorList = userUsernames;
                this.issueTags = result.issue_tags;
                TELSA.loading(false);
            });
        },

        runClick: function() {
            if(this.$refs.historicalParams.validate()) {
                if(this.historicalParams.startDateTime && this.historicalParams.endDateTime) {
                    this.$emit('run', this.historicalParams);
                }
                else {
                    this.$store.commit('showConfirmModal', {
                        title: 'Missing Required Fields',
                        message: `You must fill out a Start Date/Time and End Date/Time`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: () => {}
                    });
                }
            }
        }
    },

    created() {
    },

    mounted() {
        if(this.$props.historicalIssuesParams) {
            this.historicalParams = this.$props.historicalIssuesParams;
        }
        this.getResources();
    }

  
}
</script>

<style scoped>


</style>
